import { SettingsDataCard } from '@pages/SettingsPage/components/SettingsDataCard'
import { IElsterLatestFiling } from '@root/query/integrations/elster'
import { formatDate } from '@root/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaPaperPlane } from 'react-icons/fa'
import styled from 'styled-components'

interface Props {
  filing: IElsterLatestFiling
}

const ElsterLatestFilingCard: React.FC<Props> = ({ filing }) => {
  const [t] = useTranslation()

  return (
    <SettingsDataCard
      icon={<FaPaperPlane />}
      title={t('settings.elsterSettings.latestFiling.title')}
      body={
        <FilingRow>
          <FilingPeriod>
            {t('settings.elsterSettings.latestFiling.period', {
              startDate: formatDate(filing.start_date),
              endDate: formatDate(filing.end_date)
            })}
          </FilingPeriod>
          <FilingDate>{formatDate(filing.accepted_at)}</FilingDate>
        </FilingRow>
      }
    />
  )
}

export default ElsterLatestFilingCard

const FilingRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const FilingPeriod = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
`

const FilingDate = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.iconGray};
`
